<template>
  <div style="height: 100%;">
    <iframe-top-operation
      ref="iframeTopOperation"
      v-if="showTopOperation"
      :showBackBotton="getShowBackBotton"
    >
    </iframe-top-operation>
    <div class="mainIframe">
      <iframe ref="mainIframe"
              :id="iframeName"
              frameborder="0"
              :name="iframeName"
              scrolling="auto"
              :src="getIframeUrl"
              :width="tBodyWidth"
              :height="tBodyHeight">
      </iframe>
    </div>
  </div>
</template>
<script>
  import IframeTopOperation from './iframe-top-operation.vue'

  export default {
    components: {
      IframeTopOperation
    },
    name: 'common-iframe',
    props: {
      showBackBotton: {
        type: Boolean,
        default: false
      },
      showTopOperation: {
        type: Boolean,
        default: false
      },
      bindRouteUrl: {
        type: Boolean,
        default: true
      },
      iframeUrl: {
        type: String,
        default: ''
      },
      iframeName: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        tBodyHeight: 200,
        tBodyWidth: '100%'
      }
    },
    computed: {
      getShowBackBotton: function () {
        return this.showBackBotton
      },
      getIframeUrl: function () {
        if (this.iframeUrl) {
          return this.iframeUrl
        }
        if (this.bindRouteUrl) {
          return this.$route.meta.url
        }
      }
    },
    mounted() {
      this.tBodyAutoHeight()
    },
    methods: {
      tBodyAutoHeight() {
        let topOperationHeight = this.$refs.iframeTopOperation ? this.$refs.iframeTopOperation.$el.offsetHeight : 0
        this.tBodyWidth = this.$el.clientWidth
        this.tBodyHeight = this.$el.offsetHeight - topOperationHeight
        setTimeout(() => {
          this.tBodyAutoHeight()
        }, 200)
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/iframe/iframe.vue